import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const CompatibilityScoreCard = ({ score }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const getScoreColor = (value) => {
    if (value >= 80) return 'success';
    if (value >= 60) return 'primary';
    if (value >= 40) return 'warning';
    return 'accent';
  };

  const getTrendIcon = (trend) => {
    if (trend > 0) return 'TrendingUp';
    if (trend < 0) return 'TrendingDown';
    return 'Minus';
  };

  const getTrendColor = (trend) => {
    if (trend > 0) return 'success';
    if (trend < 0) return 'error';
    return 'muted-foreground';
  };

  const scoreColor = getScoreColor(score?.value);

  return (
    <div 
      className="bg-card border border-border rounded-lg p-4 md:p-5 shadow-therapeutic-sm hover:shadow-therapeutic transition-therapeutic cursor-pointer"
      onClick={() => setIsExpanded(!isExpanded)}
    >
      <div className="flex items-start justify-between mb-3">
        <div className={`flex items-center justify-center w-10 h-10 bg-${scoreColor}/10 rounded-md`}>
          <Icon name={score?.icon} size={20} color={`var(--color-${scoreColor})`} />
        </div>
        
        {score?.trend !== 0 && (
          <div className={`flex items-center gap-1 text-${getTrendColor(score?.trend)}`}>
            <Icon 
              name={getTrendIcon(score?.trend)} 
              size={14} 
              color="currentColor" 
            />
            <span className="text-xs font-medium">
              {Math.abs(score?.trend)}%
            </span>
          </div>
        )}
      </div>

      <div className="space-y-2">
        <div className="flex items-end justify-between">
          <span className={`text-3xl md:text-4xl font-heading font-bold text-${scoreColor}`}>
            {score?.value}%
          </span>
          <Icon 
            name={isExpanded ? 'ChevronUp' : 'ChevronDown'} 
            size={18} 
            color="var(--color-muted-foreground)" 
          />
        </div>
        
        <p className="text-sm font-medium text-foreground">
          {score?.category}
        </p>
        
        <div className="w-full bg-muted rounded-full h-2 overflow-hidden">
          <div
            className={`h-full bg-${scoreColor} transition-therapeutic`}
            style={{ width: `${score?.value}%` }}
          />
        </div>
      </div>

      {isExpanded && (
        <div className="mt-4 pt-4 border-t border-border space-y-3 animate-in fade-in duration-200">
          <p className="text-xs md:text-sm text-muted-foreground leading-relaxed">
            {score?.description}
          </p>
          
          <div className="space-y-2">
            <p className="text-xs font-medium text-foreground">Suggestions:</p>
            {score?.suggestions?.map((suggestion, index) => (
              <div key={index} className="flex items-start gap-2">
                <Icon name="CheckCircle2" size={14} color="var(--color-success)" className="mt-0.5 flex-shrink-0" />
                <span className="text-xs text-muted-foreground">{suggestion}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CompatibilityScoreCard;